import styled from 'styled-components';

import { MenuItemProps } from './interface';

export const Container = styled.td<MenuItemProps>`
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  height: 50px;
  width: 80px;
  background: ${props => (props.inHead ? 'rgba(0,0,0,0.01)' : 'rgba(0,0,0,0)')};
`;
